<template>
  <transition name="confirm">
    <div v-show="option.visible">
      <div class="hidden md:block">
        <PcView
          :option="option"
          :iconByType="iconByType"
          :isInsetEl="!!insetEl"
          @handleSubmit="handleSubmit"
          @handleCancel="handleCancel"
          @mask="mask"
        ></PcView>
      </div>
      <div class="md:hidden">
        <MbView
          :option="option"
          :iconByType="iconByType"
          @handleSubmit="handleSubmit"
          @handleCancel="handleCancel"
          @mask="mask"
        ></MbView>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { ModalOption } from './confirm';
import PcView from './PcView.vue';
import MbView from './MbView.vue';
const defaultOption: ModalOption = {
  visible: false,
  // 弹框类型
  type: 'warn',
  // 提示标题
  title: '提示',
  // 描述
  descript: '是否确认操作',
  // 确认文本
  confirmText: '确认',
  // 取消文本
  cancelText: '取消',
  // 是否展示取消
  showCancel: true,
  loading: false,
  onOk() {},
  onCancel() {},
  onFaild() {},
  // 遮罩展示
  maskClosable: false,
  position: ''
};

@Component({
  components: {
    PcView,
    MbView
  }
})
export default class CwModal extends Vue {
  option = {
    ...defaultOption
  };
  // inline 回调
  closeHook: Function | undefined;
  insetEl: HTMLDivElement | null = null;

  get iconByType() {
    switch (this.option.type) {
      case 'warn':
        return require('./assets/warn.png');
      default:
        return require('./assets/warn.png');
    }
  }

  mask() {
    if (this.option.maskClosable) {
      // 判断是否可关闭
      this.handleClose();
    }
  }

  open(
    option: ModalOption,
    inline: {
      insetEl: HTMLDivElement;
      closeHook: Function;
    }
  ) {
    this.option = {
      ...defaultOption,
      ...option
    };
    if (inline) {
      this.closeHook = inline.closeHook;
      this.insetEl = inline.insetEl;
    }
  }

  async handleSubmit() {
    try {
      if (this.option.onOk) {
        try {
          await this.option.onOk();
        } catch (error) {
          console.log('error: ', error);
          this.option?.onFaild && this.option.onFaild();
        }
      }
      this.handleClose();
    } catch (error) {
      console.log('error: ', error);
    }
  }

  async handleCancel() {
    try {
      if (this.option.onCancel) {
        await this.option.onCancel();
      }
      this.handleClose();
    } catch (error) {
      console.log('error: ', error);
    }
  }

  handleClose() {
    this.option.visible = false;
    this.closeHook && this.closeHook();
  }
}
</script>

<style scoped>
/* pc */
.modal-content {
  @apply absolute top-1/2 left-1/2 bg-white p-5;
  width: 292px;
  height: 136px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  transform: translate(-50%, -50%);
}

.content-title {
  @apply flex items-center font-medium;
  color: #3f3356;
  font-size: 16px;
}

.content-text {
  @apply my-4;
  color: rgba(63, 51, 86, 0.6);
  font-size: 14px;
}

/* button */
.operate-button {
  @apply flex justify-end;
}
.button {
  @apply py-1 px-2 tracking-widest;
  width: 78px;
  height: 34px;
  font-size: 14px;
  border-radius: 6px;
  outline: none !important;
}
.cancel-button {
  @apply mr-4;
  color: #6e57ec;
  border: 1px solid rgba(110, 87, 236, 0.2);
}
.cancel-button::before {
  content: '';
}
.confirm-button {
  @apply text-white border;
  background: #ef5d5d;
}
.disabled {
  opacity: 0.6;
}

.confirm-leave-to {
  z-index: 60;
  opacity: 0;
}
.confirm-enter-active,
.confirm-leave-active {
  transition: all 0.3s;
}
</style>
